import { CETextInput } from 'controls/react/form/formBuilderNew/fields/ceTextInput';
import { CETextEditor } from 'controls/react/form/formBuilderNew/fields/ceTextEditor';
import { CEGroup } from 'controls/react/form/formBuilderNew/fields/ceGroup';
import { CESelection } from 'controls/react/form/formBuilderNew/fields/ceSelection';
import { CEAuthentication } from 'controls/react/form/formBuilderNew/fields/ceAuthentication';
import { CERange } from 'controls/react/form/formBuilderNew/fields/ceRange';
import { CEAction } from 'controls/react/form/formBuilderNew/fields/ceAction';
import { CECheckbox } from 'controls/react/form/formBuilderNew/fields/ceCheckBox';
import { CELabel } from './fields/ceLabel';
import { CESeparator } from './fields/ceSeparator';
import { CECollection } from './fields/ceCollection';

import { Property } from 'controls/react/form/formBuilderNew/models';

import React from 'react';
import { AntAlert } from 'controls/react/ant/antAlert';
import { CESchedule } from './fields/ceSchedule';
import { CEFileChooser } from './fields/ceFileChooser';
import { CEAlgorithm } from './fields/ceAlgorithm';
import { FormBuilderStore } from './formBuilderStore';

const components = {
	CETextInput: CETextInput,
	CETextEditor: CETextEditor,
	CEGroup: CEGroup,
	CESelection: CESelection,
	CESelectionMulti: CESelection,
	CEAuthentication: CEAuthentication,
	CERange: CERange,
	CEAction: CEAction,
	CECheckBox: CECheckbox,
	CELabel: CELabel,
	CESeparator: CESeparator,
	CESchedule: CESchedule,
	CEFileChooser: CEFileChooser,
	CECollection: CECollection,
	CEAlgorithm: CEAlgorithm,
};

export const renderProperty = (property: Property, store: FormBuilderStore) => {
	if (!store.propertyVisible(property)) return null;
	const Component = components[property.type];
	if (!Component) {
		console.error('No property handler for property type: ' + property.type);
		return <AntAlert type="error" message={`No property handler for property type: ${property.type}`} />;
	}
	return <Component key={property.id} property={property} />;
};
